import { ROUTES } from '../../../constants'
import Link from 'next/link'

export default function MembershipsList() {
  return (
    <div className='heroContainer'>
      <div className='logos-container'>
        <div className='logo-button'>
          <Link legacyBehavior href={`${ROUTES.Membership}/cbauto/absolute-advantage`}>
            <a aria-label='membership-button'>
              <img
                id='AA-logo'
                src='/images/memberships/cbauto/CBAA_-_Blue_-_Horizontal-crop.png'
                alt=''
              />
            </a>
          </Link>
        </div>
        <div className='logo-button'>
          <Link legacyBehavior href={`${ROUTES.Membership}/cbauto/union-auto`}>
            <a aria-label='membership-button'>
              <img
                id='UA-logo'
                src='/images/memberships/cbauto/Union_Auto_Program_-_Blue_-_Ho.png'
                alt=''
              />
            </a>
          </Link>
        </div>
      </div>

      <style jsx>{`
        #AA-logo,
        #UA-logo {
          display: block;
          margin: auto;
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
        }
        .logos-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 100%;
          justify-content: center;
          gap: 5%;
          margin: 2rem;
        }
        .logo-button {
          max-width: 30vw;
          min-width: 176px;
          margin: 1rem 2rem;
          background-color: white;
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2.5px solid black;
        }
        .heroContainer {
          :global(.hero) {
            padding: 14.7rem 0 0;
          }
        }

        @media (max-width: 1024px) {
          .heroContainer {
            :global(.hero) {
              padding: 2.7rem 0 0;
            }
          }
        }
      `}</style>
    </div>
  )
}
